import { ReactFlowProvider } from 'reactflow';

import useBlocks from './hooks/useBlocks';
import useProjectMount from './hooks/useProjectMount';
import LeftSideBar from './sections/LeftSideBar/LeftSideBar';
import Flow from './sections/Flow/Flow';
import RightSideBar from './sections/RightSideBar/RightSideBar';
import SEO from 'components/SEO';
import Error404 from 'components/Error404';
import ProjectLoader from './components/EditorLoader';
import EditorLayout from './components/EditorLayout';
import usePageLeave from './hooks/usePageLeave';

const Editor = () => {
  const project = useProjectMount();
  const blocks = useBlocks({
    framework: project.data?.framework,
    frameworkVersion: project.data?.frameworkVersion,
  });
  usePageLeave();

  const isLoading = project.isLoading || project.isRefetching || blocks.isLoading;
  const isError = project.isError || blocks.isError;

  if (isLoading) return <ProjectLoader />;
  if (isError || !project.data || !blocks.data) return <Error404 />;

  return (
    <>
      <SEO title={project.data.projectName} />
      <ReactFlowProvider>
        <EditorLayout>
          <LeftSideBar blocks={blocks.data.blocks} />
          <Flow model={project.data.model} modelDirection={project.data.direction} />
          <RightSideBar />
        </EditorLayout>
      </ReactFlowProvider>
    </>
  );
};

export default Editor;
